import { PasswordResetScreen } from '@/features/auth/PasswordResetScreen';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/password-reset')({
  staticData: { public: true },
  validateSearch: z.object({ token: z.string().optional() }),
  component: PasswordResetScreen,
});
